// biome-ignore-all lint/a11y/useMediaCaption: live WebRTC-аудио не имеет caption-трека
/* eslint-disable jsx-a11y/media-has-caption -- аудио-сток live-звонка, caption неприменим */
import { useEffect, useRef } from 'react'
import type { ParticipantSnapshot, TrackSnapshot } from '@/entities/call'
import { usesWebAudioMix } from '@/shared/lib/livekit'

function AudioSink({ track }: { track: TrackSnapshot }) {
  const ref = useRef<HTMLAudioElement>(null)
  useEffect(() => {
    const el = ref.current
    if (!el) return
    track.attach(el)
    // Элемент на паузе после фона/телефонного interruption — тихо возобновляем;
    // autoplay-жест уже был при входе в звонок. При webAudioMix элемент звук не
    // несёт (LiveKit держит его немым, микс идёт через AudioContext) — там
    // просыпается сам контекст, в адаптере.
    const resume = () => {
      if (usesWebAudioMix()) return
      if (!document.hidden && el.paused) void el.play().catch(() => {})
    }
    document.addEventListener('visibilitychange', resume)
    window.addEventListener('pageshow', resume)
    window.addEventListener('focus', resume)
    return () => {
      document.removeEventListener('visibilitychange', resume)
      window.removeEventListener('pageshow', resume)
      window.removeEventListener('focus', resume)
      track.detach(el)
    }
  }, [track])
  return <audio ref={ref} autoPlay />
}

// Без attach удалённых аудио-треков к <audio> участников не слышно — livekit-client
// сам аудио не воспроизводит. Локальные треки не цепляем (эхо своего микрофона).
export function CallAudio({ participants }: { participants: ParticipantSnapshot[] }) {
  const tracks = participants
    .filter((p) => !p.isLocal)
    .flatMap((p) => p.tracks.filter((t) => t.kind === 'audio'))
  return (
    <>
      {tracks.map((t) => (
        <AudioSink key={t.id} track={t} />
      ))}
    </>
  )
}
